import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { checkLicensePlateFormat } from '@shared/utils';
import { LPRCountryCode } from '@shared/models';

/**
 * Some constants so we can more easily type angular typed forms
 */
export const fbOptionalString = <string | null>null;
export const fbString = <string>'';
export const fbOptionalNumber = <number | null>null;
export const fbNumber = <number>(<unknown>null);
export const fbOptionalBoolean = <boolean | null>null;
export const fbBoolean = <boolean>false;

export function requireLicensePlate(control: AbstractControl) {
  if (!control.value.license_plate) {
    return { required: true };
  }

  if (control.value.license_plate === ':' || control.value.license_plate_country === '') {
    return { required: true };
  }

  return null;
}

export const validateLicensePlate: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const licensePlate = control.value['licensePlate'] as string;
  const licensePlateCountry = control.value['licensePlateCountry'] as LPRCountryCode;
  if (!licensePlate || !licensePlateCountry) return { required: true };

  return !checkLicensePlateFormat(licensePlate, licensePlateCountry) ? { invalidFormat: true } : null;
};

export const phoneNumberValidator = Validators.pattern(/^(\+|00)[\d\s]{7,32}$/) // the max length is longer than necessary to keep in sync with the backend limits


export const setFormErrors = (errors: { [key: string]: string[] }, form: any) => {
    for (const key in errors) {
      if (errors.hasOwnProperty(key) && form.controls[key as keyof typeof form.controls]) {
        const control = form.controls[key as keyof typeof form.controls];
        control.setErrors({ serverError: errors[key].join(' ') });
      }
    }
  }